import React, { Fragment } from 'react';
import Navbar from '../../../components/Navbar';
import { Button, Col, Row } from 'react-bootstrap';
import { Grid } from 'jrgrid';
import { pageApplicationUsers, readRoles, updateRunAsMutation } from './api';
import { useMutation, useQuery } from '@apollo/client';
import { useSelector } from 'react-redux';

type AppUser = {
  id: number;
  adId: string;
  name: string;
  email: string;
};

export const RunAs = (props: any) => {
  const { user } = useSelector((state: any) => ({ user: state.user }));
  const { loading, error, data, refetch } = useQuery(readRoles, {
    variables: {
      id: user.id,
    },
  });
  const [updateRunAs] = useMutation(updateRunAsMutation)

//   React.useEffect(() => {
//     console.log(data?.readOneApplicationUser);
//   }, []);

  let filter = [];

  function selectUser({ value, row }: any) {
    if (value !== null) {
      return (
        <Button
          onClick={async () => {
            await refetch({ id: parseFloat(row.id) });
          }}>
          Select
        </Button>
      );
    } else {
      return '';
    }
  }

  const columns = [
    {
      column: {
        Header: 'Select',
        accesor: 'id',
        type: 'number',
        width: 80,
        Cell: selectUser,
      },
      type: 'number',
    },
    {
      column: {
        show: false,
        accessor: 'id',
      },
    },
    {
      column: {
        Header: 'Name',
        accessor: 'name',
        type: 'string',
      },
      type: 'string',
    },
    {
      column: {
        Header: 'AD ID',
        accessor: 'adId',
        type: 'string',
      },
      type: 'string',
    },
    {
      column: {
        Header: 'Email',
        accessor: 'emailAddress',
        type: 'string',
      },
      type: 'string',
    },
  ];
  return (
    <Fragment>
      <Navbar />
      <div className='m-2'>
        <h1>Select a User</h1>
        <Row>
          <Col md={8}>
            <Grid
              amount={8}
              columns={columns}
              query={pageApplicationUsers}
              queryName='pageApplicationUsers'
              defaultSortField='id'
              globalFilters={filter}
              queryTag='selectingUserQuery'
            />
          </Col>
          <Col md={4}>
            {loading && <div>Loading...</div>}
            {error && <div>Error...</div>}
            {data && (
              <div>
                <div>
                  <h3>User: {data.readOneApplicationUser.name}</h3>
                  <br />
                  <h3>{data.readOneApplicationUser.applicationUserRoles.length > 0 ? 'Roles:' : 'No Roles Found'} </h3>
                  {data.readOneApplicationUser.applicationUserRoles.map((role) => {
                    return <h5>{`${role.department.Abbreviation} - ${role.role.roleType}${role.isDefaultRole ? ' - Default' : ''}`}</h5>;
                  })}
                  <div style={{ flex: 1, flexDirection: 'row' }}>
                    <Button
                    className='mr-2'
                    variant='info'
                      onClick={() => {
                        updateRunAs({
                          variables: {
                            srcUser: parseFloat(data.readOneApplicationUser.id),
                            destUser: parseFloat(user.id),
                          },
                        })
                          .then((res) => alert('Please logout to apply role changes!'))
                          .catch((err) => console.log('Error: /frontend/src/pages/DevTeam/RunAs//runAs', err));
                      }}>
                      Run as {data.readOneApplicationUser.name}
                    </Button>
                    <Button
                    variant='primary'
                      onClick={() => {
                        updateRunAs({
                          variables: {
                            destUser: parseFloat(user.id),
                            reset: true,
                          },
                        })
                          .then((res) => alert('Please logout to apply role changes!'))
                          .catch((err) => console.log('Error: /frontend/src/pages/DevTeam/RunAs//reset', err));
                      }}>
                      Reset {user.name}
                    </Button>
                  </div>
                </div>
              </div>
            )}
          </Col>
        </Row>
      </div>
    </Fragment>
  );
};
